import React from 'react'
import styled from '@emotion/styled'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { colors, font, spacing } from '@mobi/component-library/Foundations'
import { formatDateTime } from '@core/Areas/Account/Pages/Activity/Components/Ticket/helpers'
import { getKambiCouponBetType } from '@core/Areas/KambiSports/Player/helpers/getKambiCouponBetType'
import { SelectionInfo } from './Components/SelectionInfo'

export const Details: React.FC<{ historyCoupon: KambiHistoryCoupon }> = ({ historyCoupon }) => {
  const shouldShowSelections = getKambiCouponBetType(historyCoupon) !== 'single'

  return (
    <WrapperStyled>
      {shouldShowSelections && <SelectionInfo historyCoupon={historyCoupon} />}

      <div>
        <div>
          <span>Event Start:</span>
          <span>{formatDateTime(historyCoupon.events[0].eventStartDate)}</span>
        </div>
        <div>
          <span>Bet Placed on:</span>
          <span>{formatDateTime(historyCoupon.placedDate)}</span>
        </div>
        <div>
          <span>Bet ID:</span>
          <span>{historyCoupon.couponRef}</span>
        </div>
      </div>
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'stretch',
  width: '100%',
  paddingTop: spacing.smx1,
  gap: spacing.sm,

  '> div:last-of-type': {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.smx1,
    alignSelf: 'stretch',

    div: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: `${spacing.smx2} 0`,
      alignItems: 'center',
      alignSelf: 'stretch',
      fontFamily: font.family.primary,
      fontSize: font.size.sm.fontSize,
      fontStyle: 'normal',
      fontWeight: font.weight.medium,
      lineHeight: font.size.sm.lineHeight,
      color: colors.neutral[800],
    },
  },
})
